class modalSureSelConCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, modalSelConDetailService) {
        httpRequest.get_getConfirmInvoice().then(res => {
            const { authAmount, authCount, authTaxamount } = res.data.value
            $scope.authAmount = (Math.round(authAmount * 100) / 100).toFixed(2)
            $scope.authCount = authCount
            $scope.authTaxamount = (Math.round(authTaxamount * 100) / 100).toFixed(2)
        })
        $scope.cancel = () => {
            $uibModalInstance.close()
        }
        $scope.ok = () => {
            const opening = window.layer.msg('正在处理，请您耐心等待···', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.get_getIsCheckOrNotOperate({ periodCode: items1.periodCode, checkType: 1 }).then(res => {
                if (res.data.value) {
                    httpRequest.post_qryIvatConfig().then((res) => {
                        // 单机版
                        if (res.data.value.diskType == 1) {
                            const singleResObj = {
                                TAXNO: res.data.value.creditCode,
                                PASS: res.data.value.diskPassword,
                                ptPassword: res.data.value.platformPassword,
                                xzsbzt: 1,
                                VERSION: '',
                                TaxType: 1,
                            }
                            const singleResJson = JSON.stringify(singleResObj)
                            const b = modalSelConDetailService.Base64()
                            const singleReqBase64 = b.encode(singleResJson).replace(/\+/g, '_')
                            $.ajax({
                                url: res.data.value.serverAddress,
                                type: 'POST',
                                data: {
                                    SID: 440304,
                                    SIDParam: singleReqBase64,
                                },
                                dataType: 'jsonp',
                                timeout: 60000,
                                success(res) {
                                    res = JSON.stringify(res)
                                    const CheckParamDTO = {
                                        checkFlag: 1,
                                        checked: items1.checked,
                                        u72Response: res,
                                        periodCode: items1.periodCode,
                                        checkType: 1,
                                        isCustomsPayment: '0',
                                    }
                                    httpRequest.post_confirmAuthLocal(CheckParamDTO).then((res) => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                        if (!res.data.success) {
                                            logger.logError(res.data.msgCode)
                                        }
                                        logger.logSuccess('提交成功，本次勾选认证成功')
                                    }, () => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                    })
                                },
                                error() {
                                    window.layer.close(opening)
                                    $scope.pageChanged()
                                    logger.logError('u72请求错误')
                                },
                            })
                        } else {
                            const CheckParamDTO = {
                                checkFlag: 1,
                                checked: items1.checked,
                                periodCode: items1.periodCode,
                                checkType: 1,
                                isCustomsPayment: '0',
                            }
                            httpRequest.post_confirmAuthServer(CheckParamDTO).then((res) => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                                if (!res.data.success) {
                                    logger.logError(res.data.msgCode)
                                }
                                logger.logSuccess('提交成功，本次勾选认证成功')
                            }, () => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                            })
                        }
                    }, () => {
                        $scope.pageChanged()
                    })
                } else {
                    logger.logError('已申请统计或确认签名，不能发票勾选，请先撤销统计或撤销签名')
                }
            })

            $uibModalInstance.close()
        }
    }
}

modalSureSelConCtrl.$inject = ['$scope', '$uibModalInstance', 'items1', 'httpRequest', 'logger', 'modalSelConDetailService']
export default modalSureSelConCtrl


// WEBPACK FOOTER //
// ./src/components/drawBack/modalConfirmConCtrl.js